import { useCallback, useEffect, useState } from "react";

import { fetchAPI, postAPI } from "../../../utils/utils";
import { createProvesFetesSync } from "./provesFetesSync";

// Un per esdeveniment i per tota la pàgina: si es tanca la llista a mig
// enviar, els tocs que falten s'acaben d'enviar i en tornar-hi encara hi són
const syncs = new Map();
const syncFor = event => {
    const key = String(event);
    if (!syncs.has(key)) {
        syncs.set(key, createProvesFetesSync({
            send: (prova, { feta, by }, onSaved, onFailed) =>
                postAPI('/prova_feta', { event, prova, feta, userId: by }, onSaved, onFailed),
        }));
    }
    return syncs.get(key);
};

// Proves ja fetes: tothom les veu tatxades i tècnica les marca amb ✓. El toc
// es pinta a l'instant i s'envia al servidor (vegeu provesFetesSync.js); la
// resta de dispositius, l'app inclosa, el reben per `.proves_fetes`.
const useProvesFetes = ({ socket, event, enabled = true, userId = null }) => {
    const sync = enabled && event ? syncFor(event) : null;
    const [fetes, setFetes] = useState(() => sync?.get() || {});

    useEffect(() => {
        setFetes(sync?.get() || {});
        return sync?.subscribe(setFetes);
    }, [sync]);

    useEffect(() => {
        if (!sync) return undefined;

        fetchAPI(`/proves_fetes/${event}`, sync.startLoad(), false);
        const onFetes = (evId, data, rev) => {
            if (parseInt(evId) === parseInt(event)) sync.receive(data, rev);
        };
        socket?.on('.proves_fetes', onFetes);
        return () => socket?.off('.proves_fetes', onFetes);
    }, [event, socket, sync]);

    const toggleFeta = useCallback(prova => {
        sync?.toggle(prova, { by: userId });
    }, [sync, userId]);

    return { fetes, toggleFeta };
};

export default useProvesFetes;
